import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ClipboardService } from 'ngx-clipboard';
import { ToastrService } from 'ngx-toastr';
import { Store } from 'src/app/core/store/store';
import { User } from 'src/app/shared/models/user.model';
import { CourseService } from 'src/app/shared/services/course.service';
import { EventsService } from 'src/app/shared/services/events.service';
import { DashboardService } from '../../services/dashboard.service';
import { environment } from 'src/environments/environment';
import { HandleSubscription } from 'src/app/shared/utils/handle-subscription';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-program-certificate',
  templateUrl: './program-certificate.component.html',
  styleUrls: ['./program-certificate.component.scss']
})
export class ProgramCertificateComponent extends HandleSubscription implements OnInit {
  user: User;
  certificateDetails: any
  constructor(private _clipboardService: ClipboardService, private router: Router, private toaster: ToastrService, private route: ActivatedRoute, private courseService: CourseService,
    private store: Store, private meta: Meta, private title: Title, /* private linkService: LinkService, */ private http: HttpClient,
      /* private modalService: NgbModal */ private dashboardService: DashboardService, 
      private eventsService: EventsService) {
    // this.seoDataFunc();
    super()
  }
  pageUrl: string = '';
  _seoJsonURL = 'assets/json/seoData.json';
  seoData: any;
  pageName: any;
  pathwayId: string;
  pathwayDetails: any;
  pathwayName: string;
  activationData: any;
  sessionOut=false;
  activationInfo: any
  private clientId = '86q3rl9y84r1o3';
  private redirectUri = `${environment.webUrl}/dashboard/certificate/share-post`;
  private scope = 'openid profile email w_member_social';
  private linkedInAuthUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&state='sdfs'&client_id=${this.clientId}&redirect_uri=${encodeURIComponent(this.redirectUri)}&scope=${encodeURIComponent(this.scope)}`;

  seoDataFunc() {
    // this.http.get(this._seoJsonURL).subscribe(data => {
    //   this.seoData = data
    //   if (this.seoData) {
    //     this.pageName = this.seoData.certificatePage;
    //     this.meta.updateTag({ name: 'keywords', content: this.pageName.keywords });
    //     this.title.setTitle(this.certificateDetails.certificateInfo.courseTitle);
    //     this.meta.updateTag({ name: 'title', property: 'og:title', content: this.certificateDetails.certificateInfo.courseTitle });
    //     this.meta.updateTag({ name: 'description', property: 'og:description', content: `Course completion certificate for ${this.certificateDetails.certificateInfo.courseTitle}, an online course offered by Harappa.` });
    //     this.meta.updateTag({ name: 'site_name', property: 'og:site_name', content: this.pageName.site_name });
    //     this.meta.updateTag({ name: 'site', property: 'og:site', content: this.pageName.site });
    //     this.meta.updateTag({ name: 'type', property: 'og:type', content: this.pageName.type });
    //     // this.linkService.removeTag('rel=canonical');
    //     // this.linkService.addTag({ rel: 'canonical', href: window.location.origin + this.router.url });
    //     this.meta.updateTag({ property: 'og:image:secure_url', content: this.certificateDetails.certificateInfo.certificateImageUrl });
    //     this.meta.updateTag({ name: 'image', property: 'og:image', content: this.certificateDetails.certificateInfo.certificateImageUrl });
    //     this.meta.updateTag({ name: 'url', property: 'og:url', content: window.location.origin + this.router.url });
    //     this.meta.updateTag({ property:"fb:app_id" ,content:"696504857788937" });
    //     this.meta.updateTag({ name:'twitter:image', content: this.certificateDetails.certificateInfo.certificateImageUrl });
    //     this.meta.updateTag({ name:'twitter:title', content: this.pageName.title });
    //     this.meta.updateTag({ name:'twitter:description', content: `Course completion certificate for ${this.certificateDetails.certificateInfo.courseTitle}, an online course offered by Harappa.` });
    //     this.meta.updateTag({ name:'twitter:card', content: "summary_large_image" });
    //   }
    // });
    
        // this.meta.updateTag({ name: 'description', property: 'og:description', content: `Course completion certificate for ${this.certificateDetails.certificateInfo.courseTitle}, an online course offered by Harappa.` });
        // this.meta.updateTag({ name: 'site_name', property: 'og:site_name', content: this.pageName.site_name });
        // this.meta.updateTag({ name: 'site', property: 'og:site', content: this.pageName.site });
        // this.meta.updateTag({ name: 'type', property: 'og:type', content: this.pageName.type });
        // // this.linkService.removeTag('rel=canonical');
        // // this.linkService.addTag({ rel: 'canonical', href: window.location.origin + this.router.url });
        // this.meta.updateTag({ property: 'og:image:secure_url', content: this.certificateDetails.certificateInfo.certificateImageUrl });
        // this.meta.updateTag({ name: 'image', property: 'og:image', content: this.certificateDetails.certificateInfo.certificateImageUrl });
        // this.meta.updateTag({ name: 'url', property: 'og:url', content: window.location.origin + this.router.url });
        // this.meta.updateTag({ property:"fb:app_id" ,content:"696504857788937" });
        // this.meta.updateTag({ name:'twitter:image', content: this.certificateDetails.certificateInfo.certificateImageUrl });
        // this.meta.updateTag({ name:'twitter:title', content: this.pageName.title });
        // this.meta.updateTag({ name:'twitter:description', content: `Course completion certificate for ${this.certificateDetails.certificateInfo.courseTitle}, an online course offered by Harappa.` });
        // this.meta.updateTag({ name:'twitter:card', content: "summary_large_image" });
  }

  ngOnInit() {
    this.pathwayName = this.route.snapshot.queryParams.pname;
    this.route.params.subscribe(params => {
      this.pathwayId = params['id'];
      if (params['id'] && !this.pathwayName)
        this.getCertificateInfo(params['id'])
    });
    this.activationInfo = JSON.parse(localStorage.getItem('activationInfo'))
    // this.getProgramActivation();

    if(localStorage.getItem("UPGRAD_IPJ_TOKEN")){
      console.log("token found")
      // this.getProgramActivation();
      this.sessionOut=false
      console.log("setting out")
    }else{
      console.log("token not found")
      this.sessionOut=true
      console.log("setting in")
    }
  }

  getCertificateInfo(id) {
    this.dashboardService.getIpjCertificate(id).subscribe(res => {
      
      if (Object.keys(res).length) {
        this.certificateDetails = res;
        localStorage.setItem('certificateImage', this.certificateDetails?.base64Url)
        // let course = this.user.visitedCourses.filter(el => el.courseName == this.certificateDetails.certificateInfo.courseTitle)
        // mixpanel.track('Visited Certificate', { 
        //   'Course Name': this.certificateDetails.certificateInfo.courseTitle,
        //   'Course Template Name': course[0].templateName,
        //   'Page Title': document.title,
        //   'User Email': this.user.email
        // });
        // this.seoDataFunc();
      } else {
        this.router.navigate(['/']);
      }
    });
  }

  copy() {
    this._clipboardService.copyFromContent(window.location.href);
    this.toaster.info("Link Copied to ClipBoard");
    this.copyLinkClicked();
    // capture event
    try {   
      if(this.certificateDetails && this.certificateDetails.certificateInfo && this.activationData) {
        let eventData = { certificate: this.certificateDetails, activationData: this.activationData }
        this.eventsService.copyCertificateLinkEvent(eventData);
      }
    } catch (err) {
      console.log(err);  
    }
  }

  shareClicked() {
    /* amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
    amplitude.getInstance().setUserId(this.user.email);
    amplitude.getInstance().setUserProperties({ 'name': this.user.name, 'organization': this.user.organization, 'cohortName': (this.user['userGroup'] || '') });
    amplitude.getInstance().logEvent('Share Certificate Clicked', { 'Course Name': this.certificateDetails.certificateInfo.courseTitle });
    console.log('View Certificate') */
  }

  downloadCertificateClicked() {
    /* amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
    amplitude.getInstance().setUserId(this.user.email);
    amplitude.getInstance().setUserProperties({ 'name': this.user.name, 'organization': this.user.organization, 'cohortName': (this.user['userGroup'] || '') });
    amplitude.getInstance().logEvent('Download Certificate', { 'Course Name': this.certificateDetails.certificateInfo.courseTitle });
    console.log('Download Certificate') */
  }

  copyLinkClicked() {
    /* amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
    amplitude.getInstance().setUserId(this.user.email);
    amplitude.getInstance().setUserProperties({ 'name': this.user.name, 'organization': this.user.organization });
    amplitude.getInstance().logEvent('Copy Certificate Link', { 'Course Name': this.certificateDetails.certificateInfo.courseTitle });
    console.log('Copy Certificate Link') */
  }

  addToLinkedIn() {
    /* amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
    amplitude.getInstance().setUserId(this.user.email);
    amplitude.getInstance().setUserProperties({ 'name': this.user.name, 'organization': this.user.organization, 'cohortName': (this.user['userGroup'] || '') });
    amplitude.getInstance().logEvent('Add Certificate to LinkedIn', { 'Course Name': this.certificateDetails.certificateInfo.courseTitle });
    console.log('Add Certificate to LinkedIn') */
  }


  share(provider) {
    let BASE_URL: string;
    if (provider == 'fb') {
      BASE_URL = 'http://www.facebook.com/sharer.php?u='
    }
    if (provider == 'twitter') {
      BASE_URL = 'https://twitter.com/intent/tweet?url='
    }
    if (provider == 'linkedin') {
      BASE_URL = 'https://www.linkedin.com/shareArticle?mini=true&url='
      this.linkedinAnylytics('Link')
    }
    this.popupWindow(`${BASE_URL}${this.fixedEncodeURIComponent(`https://ipj-api.harappa.education/api/v1/ipj/user/linkedin/preview/${this.certificateDetails?.certificateInfo?.certificateId}`)}`, 'Share Certificate', window, 600, 550);
    // capture event 
    try {   
      if(this.certificateDetails && this.certificateDetails.certificateInfo && provider && this.activationInfo) {
        let eventData = { certificate: this.certificateDetails, provider: provider, activationData: this.activationInfo }
        this.eventsService.shareCertificateEvent(eventData);
      }
    } catch (err) {
      console.log(err);  
    }
  }

  popupWindow(url, title, win, w, h) {
    const y = win.top.outerHeight / 2 + win.top.screenY - (h / 2);
    const x = win.top.outerWidth / 2 + win.top.screenX - (w / 2);
    return win.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + y + ', left=' + x);
  }

  fixedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
      return '%' + c.charCodeAt(0).toString(16);
    });
  }
  openModal() {
    // needs to be uncommnet
    // const modalRef = this.modalService.open(QueryPopupComponent,{ windowClass: 'modal-cntrl modal-cntrl-sm',centered: true  });
    // modalRef.componentInstance.id = this.certificateDetails.certificateInfo.certificateId;
    // modalRef.componentInstance.courseTitle = this.certificateDetails.certificateInfo.courseTitle;
  }

  getProgramActivation() {
    this.dashboardService.getProgramActivation().subscribe((res) => {
      if(res && res['data'] && res['data'].length) {
        this.activationData = res['data'][0];
        /* this.store.set('courseStart', null);
        this.store.set('zoomStart', null);
        this.store.set('activation', res['data']); */
      }
    });
  }

  async downloadImage(imageUrl) {
    try {
      const link = document.createElement("a");
    link.href = imageUrl
    link.setAttribute("download", "certificate.jpeg");
    link.setAttribute("target", "_blank"); // fallback
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    } catch (error) {
      console.error("Download failed", error);
    }
  }

  openLinkedin() {
    window.location.href = this.linkedInAuthUrl;
  }

  linkedinAnylytics(Post) {
    let opts = {
      "firstName": this.certificateDetails?.firstName,
      "lastName": this.certificateDetails?.lastName,
      "email": this.certificateDetails?.email,
      "programTemplateName": this.certificateDetails.certificateInfo?.programTitle,
      "method": 'Linkedin',
      "organization": this.activationInfo?.organization,
      "type": Post,
      "date": new Date(),
      "photoCount": 0,
      "postId": ''
    }
    this.dashboardService.linkedinAnylytics(opts).subscribe(res => {

    })
  }
}
